import { call, put, all, takeLatest } from "redux-saga/effects";
import * as api from "constants/api";
import { handleError } from "./ApiError";
import {
    GET_EMAIL_LOGS,
    SG_GET_EMAIL_LOGS,
    FETCH_EMAIL_LOG,
    SG_FETCH_EMAIL_LOG,
    GET_EMAILS_DELIVERY_STATS,
    SG_GET_EMAILS_DELIVERY_STATS,
} from "constants/actions";

/* Email logs */

function* loadEmailLogs(action) {
    try {
        const json = yield call(api.GET_APV2_EMAILS, action.payload);
        yield put({ type: GET_EMAIL_LOGS, payload: json.data });
    } catch (e) {
        yield call(handleError, e);
    }
}

export function* emailsLoad() {
    yield takeLatest(SG_GET_EMAIL_LOGS, loadEmailLogs);
}

function* fetchEmailLog(action) {
    try {
        const json = yield call(api.FETCH_APV2_EMAIL, action.payload);
        yield put({ type: FETCH_EMAIL_LOG, payload: json.data });
    } catch (e) {
        yield call(handleError, e);
    }
}

export function* emailFetch() {
    yield takeLatest(SG_FETCH_EMAIL_LOG, fetchEmailLog);
}

function* loadEmailsDeliveryStats(action) {
    try {
        const json = yield call(api.EMAILS_DELIVERY_STATS, action.payload);
        yield put({ type: GET_EMAILS_DELIVERY_STATS, payload: json.data });
    } catch (e) {
        yield call(handleError, e);
    }
}

export function* emailsDeliveryStatsLoad() {
    yield takeLatest(SG_GET_EMAILS_DELIVERY_STATS, loadEmailsDeliveryStats);
}

export default function* index() {
    yield all([
        emailsLoad(),
        emailFetch(),
        emailsDeliveryStatsLoad(),
    ]);
}
